import styled from 'styled-components';
export var LoadingWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__LoadingWrapper",
  componentId: "sc-1yb01t0-0"
})(["display:block;align-items:center;display:flex;flex:1;height:", ";min-height:50px;justify-content:center;"], function (props) {
  return props.fullHeight ? '100%' : 'auto';
});